import React, {ReactNode, useEffect, useLayoutEffect, useState} from "react";
import AdminSideNav from "../../components/sidenav/AdminSideNav";
import "../../styles/css/admin-style.css"
import Header from "./Header";
import $ from "jquery";
import {Outlet, useLocation} from "react-router-dom";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../eventEmitter";
import {EventEmitterTypes} from "../eventEmitterEnum";
import {usePageData} from "./PageContext";
import LoadingSpinner from "./loadingSpinner";
import {useLoading} from "./LoadingContext";

interface PageWrapperProps {
    isAdmin: boolean;
}
export type ModalName = 'newSuperAdmin' | 'newYearSetup' | 'newCustomer' | 'copyPreviousYears'
export type ModalData = { [key: string]: any }
const PageWrapper = ({ isAdmin }: PageWrapperProps) => {
    //side bar stuff
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
    const { isLoading } = useLoading();
    useEffect(() => {
        $(window).on('load', () => {
            $('.pre-loader').fadeOut('fast');
        });

        return () => {
            $(window).off('load');
        };
    }, []);
    useEffect(() => {
        document.body.classList.toggle('sb-sidenav-toggled', !isSidebarOpen);
    },[isSidebarOpen])
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen)
    };

    
    useLayoutEffect(() => {
        const openSidebar = () => {
            setIsSidebarOpen(true)
        };
        const closeSidebar = () => {
            setIsSidebarOpen(false)
        };
        function handleIsSidebarOpen(callback: (isOpen: boolean) => void) {
            callback(isSidebarOpen);
        }
        eventEmitter.on(EventEmitterTypes.GET_IS_SIDEBAR_OPEN, handleIsSidebarOpen);
        eventEmitter.on(EventEmitterTypes.TOGGLE_SIDEBAR, toggleSidebar);
        eventEmitter.on(EventEmitterTypes.CLOSE_SIDEBAR, closeSidebar);
        eventEmitter.on(EventEmitterTypes.OPEN_SIDEBAR, openSidebar);

        return () => {
            eventEmitter.off(EventEmitterTypes.GET_IS_SIDEBAR_OPEN, handleIsSidebarOpen);
            eventEmitter.off(EventEmitterTypes.TOGGLE_SIDEBAR, toggleSidebar);
            eventEmitter.off(EventEmitterTypes.CLOSE_SIDEBAR, closeSidebar);
        };
    }, [isSidebarOpen]);

    // pages can pass data to header using this. used to populate modals that appear in the header
    const { pageData, resetPageData } = usePageData()
    const [activeModal, setActiveModal] = React.useState<ModalName | null>(null)
    const [modalData, setModalData]     = React.useState<any>(null)
    const location = useLocation()

    const openModal = (name: ModalName, data?: any) => {
        setModalData(data ?? null)
        setActiveModal(name)
    }
    const closeModal = () => {
        setActiveModal(null)
        setModalData(null)
    }

    useEffect(() => {
        resetPageData()
    }, [location.pathname, resetPageData])
    
    return (
        <>
            {isAdmin && <div className="page-wrap d-flex">
                <nav id="admin-menu-inc">
                    <AdminSideNav />
                </nav>
                <div className="page-container overflow-y-auto">
                    <nav id="admin-header" className="navbar navbar-light bg-white">
                        <Header toggleSidebar={toggleSidebar}
                                activeModal={activeModal}
                                modalData={modalData}
                                openModal={openModal}
                                closeModal={closeModal}/>
                    </nav>
                    <div className={isLoading ? "d-none" : ""} aria-busy={isLoading}>
                        <Outlet context={{openModal}} />
                    </div>

                    {isLoading && (
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75"
                            style={{ zIndex: 10 }}
                        >
                            <LoadingSpinner />
                        </div>
                    )}
                </div>
            </div>}
            {!isAdmin && <Outlet />}
        </>
    );
};

export default PageWrapper;
